import React from 'react';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { ElementGroup, ElementLabel } from './BaseElements';
export const BooleanActionDetail = observer(({
  name,
  checked,
  toggle
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement(ElementLabel, null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: checked,
    onChange: toggle
  }), "\xA0", name));
});